module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "md": 8
    }
  }, [_c('h1', {
    staticClass: "pageTitle"
  }, [_c('i', {
    staticClass: "fa fa-list-alt",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.index.title')) + " (" + _vm._s(_vm.orders.pagination.totalCount) + ")")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "md": 16
    }
  }, [_c('div', {
    staticClass: "listOptions pull-right"
  }, [_c('el-button-group', [_c('el-button', {
    attrs: {
      "type": _vm.primary,
      "size": "small",
      "icon": "el-icon-menu",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeView('info')
      }
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": _vm.info,
      "size": "small",
      "icon": "el-icon-tickets",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeView('primary')
      }
    }
  })], 1), _vm._v(" "), _c('v-text', {
    staticClass: "searchForm",
    attrs: {
      "name": "search",
      "type": "text",
      "translation": "search.title",
      "value": _vm.search,
      "clearable": true
    },
    on: {
      "keydown": _vm.onChangeSearch
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('sort.title')) + " ")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "allType",
      "translation": "static.clients.index.listing",
      "options": _vm.listTypes,
      "value": _vm.allType
    },
    on: {
      "change": _vm.onChange
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "sort",
      "translation": "static.clients.index.sortName",
      "options": _vm.sortTypes,
      "value": _vm.sort
    },
    on: {
      "change": _vm.onChange
    }
  })], 1)])], 1), _vm._v(" "), (_vm.showAction) ? _c('el-row', {
    staticClass: "bulkActions",
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    attrs: {
      "md": 8,
      "lg": 6,
      "xl": 4
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.selectedCount) + " orders selected")])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "md": 3,
      "lg": 3,
      "xl": 2
    }
  }, [(_vm.showAction) ? _c('label', [_vm._v(_vm._s(_vm.$t('orderActions.select.label')) + " ")]) : _vm._e()]), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 13,
      "lg": 15,
      "xl": 18
    }
  }, [_c('button', {
    staticClass: "el-button el-button--default small",
    staticStyle: {
      "margin-bottom": "4px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onSelectAction('confirmOrderAndShipping')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('orderActions.confirmOrderAndShipping')))]), _vm._v(" "), _c('button', {
    staticClass: "el-button el-button--default small",
    staticStyle: {
      "margin-bottom": "4px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onSelectAction('dowloadDeliverySlip')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('orderActions.dowloadDeliverySlip')))]), _vm._v(" "), _c('button', {
    staticClass: "el-button el-button--danger danger small",
    staticStyle: {
      "margin-bottom": "4px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onSelectAction('cancelOrder')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('orderActions.cancelOrder')))])])], 1) : _vm._e(), _vm._v(" "), (_vm.info == 'info') ? _c('el-row', {
    attrs: {
      "gutter": 5
    }
  }, [(_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (true),
      expression: "true"
    }],
    staticStyle: {
      "background": "transparent"
    }
  }, [_c('br'), _c('br')]) : _c('div', {
    staticClass: "flex stretch wrap"
  }, [(_vm.ordersList.length === 0) ? _c('v-no-data', [(_vm.isOrderOverview) ? _c('p', [_vm._v(_vm._s(_vm.$t('static.defaultText.order.noDataMsg')))]) : _vm._e(), _vm._v(" "), (_vm.isEdiOverview) ? _c('p', [_vm._v(_vm._s(_vm.$t('static.defaultText.edi.noDataMsg')))]) : _vm._e(), _vm._v(" "), (_vm.isOrderOverview) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'orders.create'
      }
    }
  }, [_vm._v("\n           "), _c('el-button', [_vm._v("\n            " + _vm._s(_vm.$t('static.defaultText.order.noDataBtn')) + "\n          ")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.ordersList), function(order, i) {
    return _c('v-card', {
      key: i,
      nativeOn: {
        "click": function($event) {
          return _vm.editOrder(order)
        }
      }
    }, [_c('label', {
      staticClass: "cardLabel full-w"
    }, [_c('span', [_vm._v("\n            #" + _vm._s(order.number) + "\n            "), _c('span', {
      staticClass: "cardBadge"
    }, [_vm._v(_vm._s(_vm.$t(("static.orders.types." + (order.orderType.toLowerCase())))))])]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-external-link pull-right",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.editOrderNewTab(order)
        }
      }
    })]), _vm._v(" "), _c('h2', {
      staticClass: "cardTitle"
    }, [_vm._v(_vm._s(order.service || order.value))]), _vm._v(" "), _c('span', {
      staticClass: "cardLabel"
    }, [_vm._v(_vm._s(order.amount))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('span', {
      staticClass: "cardTitle"
    }, [_vm._v(_vm._s(order.clientName) + " " + _vm._s(order.ediStore))]), _vm._v(" "), _c('div', {
      staticClass: "cardinnerBox"
    }, [_c('div', [_c('label', {
      staticClass: "cardLabel cardLabel--small"
    }, [_c('i', {
      staticClass: "fa fa-info",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" " + _vm._s(_vm.$t('static.orders.index.type')) + ":\n            ")]), _vm._v(" "), _c('span', {
      staticClass: "cardContent cardContent--small"
    }, [_vm._v("\n              " + _vm._s(_vm.$t(("static.orders.types." + (order.orderType.toLowerCase())))) + " ( " + _vm._s(order.ediType) + " )\n            ")])]), _vm._v(" "), (order.ediOrderId) ? _c('div', [_c('label', {
      staticClass: "cardLabel cardLabel--small"
    }, [_c('i', {
      staticClass: "fa fa-info",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" " + _vm._s(_vm.$t('static.orders.index.ediNumber')) + ":\n            ")]), _vm._v(" "), _c('span', {
      staticClass: "cardContent cardContent--small"
    }, [_vm._v("\n              " + _vm._s(order.orderNumber) + "\n            ")])]) : _vm._e(), _vm._v(" "), _c('div', [_c('label', {
      staticClass: "cardLabel cardLabel--small"
    }, [_c('i', {
      staticClass: "fa fa-clock-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" " + _vm._s(_vm.$t('static.orders.index.createdDate')) + ":\n            ")]), _vm._v(" "), _c('span', {
      staticClass: "cardContent cardContent--small"
    }, [_vm._v("\n              " + _vm._s(_vm.formatDate(order.createdDate)) + "\n            ")])]), _vm._v(" "), (order.ediOrderId) ? _c('div', [_c('label', {
      staticClass: "cardLabel cardLabel--small"
    }, [_c('i', {
      staticClass: "fa fa-clock-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" " + _vm._s(_vm.$t('static.orders.index.deliveryDate')) + ":\n            ")]), _vm._v(" "), _c('span', {
      staticClass: "cardContent cardContent--small"
    }, [_vm._v("\n              " + _vm._s(_vm.formatDate(order.ediRequestedDeliveryDate)) + "\n            ")])]) : _vm._e(), _vm._v(" "), (order.pickupDate) ? _c('div', [_c('label', {
      staticClass: "cardLabel cardLabel--small"
    }, [_c('i', {
      staticClass: "fa fa-clock-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" " + _vm._s(_vm.$t('static.orders.index.pickupDate')) + ":\n            ")]), _vm._v(" "), _c('span', {
      staticClass: "cardContent cardContent--small"
    }, [_vm._v("\n              " + _vm._s(order.pickupDate) + "\n            ")])]) : _vm._e(), _vm._v(" "), _c('div', [_c('label', {
      staticClass: "cardLabel cardLabel--small"
    }, [_c('i', {
      staticClass: "fa fa-info",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" " + _vm._s(_vm.$t('static.orders.index.status')) + ":\n            ")]), _vm._v(" "), (order.ediOrderId) ? _c('span', {
      staticClass: "cardContent cardContent--small status_",
      class: order.ediStatus
    }, [_vm._v("\n              " + _vm._s(_vm.$t(("static.ediOrders.index." + (order.ediStatus.toLowerCase())))) + " " + _vm._s(order.sendVia != '' ? ("via " + (order.sendVia)) : '') + "\n            ")]) : _c('span', {
      staticClass: "cardContent cardContent--small status_",
      class: order.orderStatus
    }, [_vm._v("\n              " + _vm._s(_vm.$t(("static.orders.status." + (order.orderStatus.toLowerCase())))) + " " + _vm._s(order.orderStatus.toLowerCase() !== 'cancelled' && order.sendVia != '' ? ("via " + (order.sendVia)) : '') + "\n            ")])]), _vm._v(" "), (order.referenceNumber && !order.ediOrderId) ? _c('div', [_c('label', {
      staticClass: "cardLabel cardLabel--small"
    }, [_c('i', {
      staticClass: "fa fa-info",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" " + _vm._s(_vm.$t('static.orders.index.referenceNumber')) + ":\n            ")]), _vm._v(" "), _c('span', {
      staticClass: "cardContent cardContent--small "
    }, [_vm._v("\n              " + _vm._s(order.referenceNumber) + "\n            ")])]) : _vm._e()])])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.primary == 'info') ? _c('el-row', {
    attrs: {
      "gutter": 5
    }
  }, [(_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (true),
      expression: "true"
    }],
    staticStyle: {
      "background": "transparent"
    }
  }, [_c('br'), _c('br')]) : _c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.ordersListView
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "30"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [(props.row.orderProducts.length) ? _c('ul', _vm._l((props.row.orderProducts), function(product) {
          return _c('li', {
            key: product.id
          }, [_c('span', {
            staticStyle: {
              "font-family": "'robotobold'"
            }
          }, [_vm._v(_vm._s(product.quantity) + " STK")]), _vm._v(" — "), _c('span', {
            staticStyle: {
              "font-family": "'robotobold'"
            }
          }, [_vm._v(_vm._s(product.name))])])
        }), 0) : _c('span', [_vm._v(_vm._s(_vm.$t('static.orders.index.noProductFound')))])]
      }
    }], null, false, 3060253977)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('static.orders.table.name'),
      "width": "100",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'orders.edit',
              params: {
                id: scope.row.id
              }
            }
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }], null, false, 2254629758)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "type",
      "label": _vm.$t('static.orders.table.type'),
      "width": "90",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "status",
      "label": _vm.$t('static.orders.table.status'),
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "clientName",
      "label": _vm.$t('static.orders.table.clientName'),
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "totalValue",
      "label": _vm.$t('static.orders.table.totalValue'),
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "totalQuantity",
      "label": _vm.$t('static.orders.table.totalQuantity'),
      "width": "100",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "createdDate",
      "label": _vm.$t('static.orders.table.createdDate'),
      "sortable": ""
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
    staticClass: "pagination"
  }, [_c('v-pagination', {
    attrs: {
      "sizePerPage": _vm.perPage,
      "pagination": _vm.orders.pagination,
      "switchFunction": _vm.all
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50f7c750","hasScoped":true}!./src/app/pages/withNavigation/orders/index/index.html
// module id = 3008
// module chunks = 1